import {
  ButtonExternalRecord,
  ButtonRecord as DatoButtonRecord,
  DownloadButtonRecord,
  HubspotButtonRecord,
} from "@graphql/types/graphql";
import { IconType } from "./icons";

export type GridCountRange = "2" | "3" | "4";

export enum Breakpoints {
  mobile = 768,
  tablet = 1123,
  desktop = 1280,
}

export interface ILink {
  href: string;
  slug?: string;
}

export interface ISocialLink {
  id: string;
  url: string;
  icon: IconType;
}

export interface IBreadcrumb {
  href?: string;
  label: string;
}

export interface IButton {
  label: string;
  text?: string;
  link?: ILink;
  file?: any;
  requireEmail?: boolean;
  theme?: "none" | "light" | "dark" | "textual" | "textual-white";
  icon?: IconType;
  iconSize?: "xxs" | "xs" | "s" | "m" | "l" | "xl";
  preIcon?: boolean;
  mirrorIcon?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  hubspotCodeSnippet?: string;
  openLinkInNewTab?: boolean;
}

export interface ITag {
  link: ILink;
  label: string;
  childrenLinks?: ITag[];
}

export enum GeoStatus {
  Idle = "idle",
  Pending = "pending",
  Timeout = "timeout",
  Unavailable = "unavailable",
  Denied = "denied",
  Geocoding = "geocoding",
  Success = "success",
}

export interface ICoordinates {
  latitude: number;
  longitude: number;
}

// Color utilities
export enum IColor {
  LightGrey = "#F5F5F5",
  LightBlue = "#F0F5FD",
}

// Sitemap utilities
export interface ISitemapPage {
  _publishedAt: string;
  slugs: any[];
}

export type ButtonRecord =
  | DatoButtonRecord
  | ButtonExternalRecord
  | DownloadButtonRecord
  | HubspotButtonRecord;
